import {ProjectFeatureFlag} from 'common/report/constants';

import {QuerySuperEntry, SelectorType, SelectorTypeDefinitions} from '../types';
import {EntryRowConstructor, EntryRowProps} from './base/types';
import {FilterEntryRow} from './filter';
import {FlowsEntryRow} from './flows-entry';
import {GroupedEntryRow} from './grouped-entry';
import {CohortGroupEntryRow} from './inline-cohort';
import {SegmentEntryRow} from './segment-entry';
import {SuperEntryRow} from './super-entry';

type EntryRowConstructorMap = {[key in SelectorType]?: EntryRowConstructor<QuerySuperEntry>};

// defines instances of empty entries for the different selector types
const EMPTY_ROW_MAP = {
  [SelectorTypeDefinitions.Filter]: () => FilterEntryRow.getNewEntry(),
  [SelectorTypeDefinitions.FlowsEvent]: () => FlowsEntryRow.getNewEntry(),
  [SelectorTypeDefinitions.PropertyExpansion]: () => ({
    type: SelectorTypeDefinitions.PropertyExpansion,
    event: null,
    filters: [],
  }),
};

/**
 * Returns an instance of EntryRow that handles selection logic for a given entry type
 */
export function createEntryRow(
  type: SelectorType,
  props: EntryRowProps<QuerySuperEntry>,
  _featureFlags: {[k in ProjectFeatureFlag]?: boolean} = {},
) {
  /** Defines a mapping for row constructors for all entry types */
  const SelectorTypeRowMap: EntryRowConstructorMap = {
    [SelectorTypeDefinitions.GroupedEvent]: GroupedEntryRow,
    [SelectorTypeDefinitions.Filter]: FilterEntryRow,
    [SelectorTypeDefinitions.FlowsEvent]: FlowsEntryRow,
    [SelectorTypeDefinitions.CohortGroup]: CohortGroupEntryRow,

    [SelectorTypeDefinitions.Segment]: SegmentEntryRow,
  };

  const rowClass = SelectorTypeRowMap[type] ?? SuperEntryRow;
  return new rowClass(props);
}

/**
 * Generates an empty entry for a given selector type
 */
export function getNewEmptyEntry(type: SelectorType): QuerySuperEntry {
  // TODO(pablo): return null as a way of expressing this should be delegated
  // to mp-query-entry-section, this will be removed to always return from
  // generating an empty entry from the given EntryRow class that's associated
  // with that type of entry
  return EMPTY_ROW_MAP[type] ? EMPTY_ROW_MAP[type]() : null;
}
